var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { Button, Input, Flex, Center, Box, Container, Text } from "@chakra-ui/react";
import { Greetings } from "./GreetingView";
import { StoreContext } from "../uistore/Rootstore";
import { FiArrowRight } from "@react-icons/all-files/fi/FiArrowRight";
import { AppColor } from "../const/AppDefaults";
import { ProgressBar } from "../UIComponents/ProgressBar";
let LoginViaDevice = class LoginViaDevice extends React.Component {
    login() {
        const rstore = this.context;
        rstore.loginViaDeviceUIStore.login();
    }
    componentWillUnmount() {
        const rstore = this.context;
        rstore.loginViewStore.reset();
    }
    reset() {
        const rstore = this.context;
        rstore.confirmStore.setMessage("Are you sure you want to reset organisation?");
        rstore.confirmStore.setOpen(true);
        rstore.confirmStore.setOkCB(() => {
            rstore.authStore.wipe();
        });
    }
    showRegisterView() {
        const rstore = this.context;
        rstore.authStore.setShowLoginViaDevice(false);
    }
    render() {
        const rstore = this.context;
        const appDefaultColour = AppColor.Default;
        return (React.createElement(Center, null,
            React.createElement(Box, { mt: '5%', h: (window.innerHeight - 150) + "px", className: 'login-container' },
                React.createElement(Greetings, null),
                React.createElement(Box, null,
                    rstore.loginViewStore.tryinglogin && React.createElement(Box, null,
                        React.createElement(ProgressBar, { state: rstore.loginViewStore.progressstate })),
                    !rstore.loginViewStore.tryinglogin && React.createElement(Box, null,
                        React.createElement(Container, null,
                            React.createElement(Center, null,
                                React.createElement(Flex, { flexDirection: 'row' },
                                    React.createElement(Box, null,
                                        React.createElement(Text, { style: { color: AppColor.GreetingMessage } }, 'Device code ')),
                                    React.createElement(Box, { ml: 10 },
                                        React.createElement(Text, { style: { color: '#ffd70b', fontWeight: 'bold' } }, rstore.loginViaDeviceUIStore.mydevicecode)))),
                            React.createElement(Center, { mt: 10 },
                                React.createElement(Box, null,
                                    React.createElement(Input, { focusBorderColor: AppColor.HeaderIconColor, variant: "outline", placeholder: "App Code", onChange: (e) => rstore.loginViaDeviceUIStore.setAppCode(e.currentTarget.value) }))),
                            React.createElement(Center, { mt: 10 },
                                React.createElement(Box, null,
                                    React.createElement(Input, { focusBorderColor: AppColor.HeaderIconColor, variant: "outline", placeholder: "App Id", onChange: (e) => rstore.loginViaDeviceUIStore.setAppId(e.currentTarget.value) })))),
                        React.createElement(Flex, { mt: '15px', flexDirection: 'column', alignItems: 'center' },
                            React.createElement(Button, { colorScheme: 'lwcolor', disabled: rstore.loginViaDeviceUIStore.appcode !== '' && rstore.loginViaDeviceUIStore.appid !== '' ? false : true, onClick: () => this.login(), rightIcon: React.createElement(FiArrowRight, null), size: 'sm', variant: "solid" }, "Login")),
                        React.createElement(Flex, { mt: '15px', mb: '15px', flexDirection: 'column', alignItems: 'center' },
                            React.createElement(Button, { onClick: () => this.showRegisterView(), size: 'sm', color: AppColor.LoginButtonIconColor, variant: 'link' }, "Register")))))));
    }
};
LoginViaDevice.contextType = StoreContext;
LoginViaDevice = __decorate([
    observer
], LoginViaDevice);
export { LoginViaDevice };
